import { BillingEventData } from "@/common/types/billing/event.type";
import { formatDateTime } from "@/common/utils/formatters";

const EventResume = ({ event }: { event?: BillingEventData }) => {
  return (
    <div className="flex flex-col gap-3">
      <h3 className="text-xl font-bold">Resumo da transação</h3>

      <div>
        <div className="flex flex-col gap-4">
          {event?.eventable?.establishment_branch?.general_information.fantasy_name && (
            <div className="flex flex-col gap-1">
              <p className="italic font-light text-xs">Estabelecimento</p>
              <p className="font-bold text-md">{event?.eventable?.establishment_branch?.general_information.fantasy_name}</p>
            </div>
          )}

          <div className="flex gap-8">
            <div className="flex flex-col gap-1">
              <p className="italic font-light text-xs">Data e hora da transação</p>
              <p className="font-bold text-md">{event?.created_at && formatDateTime(new Date(event?.created_at))}</p>
            </div>
          </div>

          {event?.eventable?.client_branch && (
            <div className="flex gap-8">
              <div className="flex flex-col gap-1">
                <p className="italic font-light text-xs">Filial</p>

                <p>
                  {event?.eventable?.client_branch?.display_name || '--'}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventResume;
